<template>
  <div class="bg-white sm:border sm:border-gray-200 sm:rounded-lg">
    <div
      v-if="title"
      class="flex items-center justify-between py-3.5 px-5 sm:border-b sm:border-b-gray-200"
    >
      <h3 class="font-semibold">{{ title }}</h3>
      <slot name="right"></slot>
    </div>
    <div class="px-5 pb-3.5 sm:pt-3.5">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title?: string;
}>();
</script>
